import { HttpResponse } from '@angular/common/http';

/**
 * @description Calculates scrollbar width
 * @export
 * @returns {number} Value in px
 */
export function getFileNameFromResponse(
  res: HttpResponse<ArrayBuffer | Blob>,
  defaultName = 'file.pdf'
): string {
  const cd = res.headers.get('Content-Disposition');
  return cd.match(/filename="?(.*?[^";]*)/i)[1] || defaultName;
}
